
export const selectsHours = [1, 5, 10, 15, 24, 36, 48]

export const minimumSelect = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]

export const times = [
  { value: "MINUTES", label: "Minutes" },
  { value: "HOURS", label: "Hours" },
  { value: "DAYS", label: "Days" }
]

export const cancellationOptions = [
  { value: "FULL_REFUND", label: "Full Refund" },
  { value: "PARTIAL_REFUND", label: "Partial Refund" },
  { value: "CHANGES", label: "Changes" }
]

export const fieldsServicesAreas = [
  {
    key: "areaCode",
    label: "Area Code",
    sortable: true,
    thStyle: { minWidth: "160px", paddingLeft: "15px !important" },
    class: "text-left pl-3"
  },
  {
    key: "description",
    label: "Area Description",
    sortable: true,
    thStyle: { minWidth: "200px" },
    class: "text-left"
  },

  {
    key: "baseprice",
    label: "Base Price",
    sortable: true,
    thStyle: { minWidth: "160px" },
    class: "text-right"
  },
  {
    key: "priceextra",
    label: "Price Extra",
    sortable: true,
    thStyle: { minWidth: "100px" },
    class: "text-right"
  },
  {
    key: "Actions",
    label: "actions",
    sortable: false,
    thStyle: { minWidth: "100px" },
    class: "alinmov6"
  }
]

export const fieldsSurcharges = [
  {
    key: "event",
    label: "Event",
    sortable: true,
    thStyle: { minWidth: "160px", paddingLeft: "15px !important" },
    class: "text-left pl-3"
  },
  {
    key: "description",
    label: "Description",
    sortable: true,
    thStyle: { minWidth: "200px" },
    class: "text-left"
  },

  {
    key: "markupType",
    label: "Surcharge",
    sortable: true,
    thStyle: { minWidth: "160px" },
    class: "text-left"
  },
  {
    key: "value",
    label: "Value",
    sortable: true,
    thStyle: { minWidth: "100px" },
    class: "text-left"
  },

  {
    key: "from",
    label: "from",
    sortable: true,
    thStyle: { minWidth: "100px" },
    class: "text-left"
  },

  {
    key: "end",
    label: "End",
    sortable: true,
    thStyle: { minWidth: "100px" },
    class: "text-left"
  },

  {
    key: "status",
    label: "Status",
    sortable: true,
    thStyle: { minWidth: "100px" },
    class: "text-center"
  },
  {
    key: "Actions",
    label: "actions",
    sortable: false,
    thStyle: { minWidth: "100px" },
    class: "alinmov6"
  }
]

export const fields = [
  {
    key: "selected",
    label: "",
    sortable: false,
    class: "text-center",
    thStyle: { minWidth: "40px" }
  },
  {
    key: "category",
    label: "Category",
    sortable: true,
    thStyle: { minWidth: "160px" },
    class: "text-left"
  },
  {
    key: "type",
    label: "Vehicle Type",
    sortable: true,
    thStyle: { minWidth: "100px" },
    class: "text-left"
  },
  {
    key: "model",
    label: "Make/Model",
    sortable: true,
    thStyle: { minWidth: "160px" },
    class: "text-left"
  },
  {
    key: "seats",
    label: "Seats",
    sortable: true,
    thStyle: { minWidth: "100px" },
    class: "text-right"
  },
  {
    key: "bags",
    label: "Bags",
    sortable: true,
    thStyle: { minWidth: "100px", paddingRight: "15px !important" },
    class: "text-right pr-3"
  },
  {
    key: "tags",
    label: "Tags",
    sortable: true,
    thStyle: { minWidth: "180px", paddingRight: "15px !important" },
    class: "text-left pr-3"
  }
]

export const coins = [
  { code: "USD", symbol: "$", label: "US Dollar" },
  { code: "EUR", symbol: "€", label: "Euro" },
  { code: "GBP", symbol: "£", label: "British Pound" },
  { code: "CHF", symbol: "₣", label: "Swiss Franc" },
  { code: "DKK", symbol: "kr", label: "Denmark Krone" },
  { code: "SEK", symbol: "kr", label: "Swedish Krona" },
  { code: "NOK", symbol: "kr", label: "Norwegian Krone" },
  { code: "ISK", symbol: "kr", label: "Icelandic Króna" },
  { code: "AED", symbol: "د.إ", label: "United Arab Emirates Dirham" }
]
export const termsConditions = "Arrivals by Plane: Our chauffeur will meet you in the arrivals lounge after luggage pickup, holding a sign with the lead passenger’s name. We offer 60 minutes of free waiting time. If you don’t arrive or notify us within this period, the transfer will be marked as a NO SHOW and fully charged. For lost luggage or customs delays, please inform us before the waiting time expires. If you miss a connecting flight, notify us promptly to reschedule. Flight cancellations result in automatic free transfer cancellation. Arrivals by Train or Cruise: Our chauffeur will wait at a designated meeting point near your arrival platform, holding a sign with the lead passenger’s name. Departures: Pick-up is from your specified location. The free waiting period is 20 minutes."